(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fec-pack-final-conversion-block"] && !Shopify.designMode) return;
  try {
    
  class FxFinalConversionBlock {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('form[data-type="add-to-cart-form"]');
      this.variantInput = section.querySelector('[data-fx-final-variant-id]');

      this.bindVariantChange();
    }

    bindVariantChange() {
      document.addEventListener('variant:change', (event) => {
        const variant = event.detail && event.detail.variant;
        if (!variant || !this.variantInput) return;

        this.variantInput.value = variant.id;
      });
    }
  }

  document.querySelectorAll('.fx-final-conversion').forEach((section) => {
    new FxFinalConversionBlock(section);
  });

  } catch(e) { console.error(e); }
})();
})();
